export default __webpack_public_path__ + "static/life-under-covid-e47ca98185850c3cf3dff3a6c265e99c.jpg";